(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["oddcats-home"] && !Shopify.designMode) return;
  try {
    
  document.querySelectorAll('[data-oddcats-gallery]').forEach((gallery) => {
    const track = gallery.querySelector('[data-gallery-track]');
    const previous = gallery.querySelector('[data-gallery-prev]');
    const next = gallery.querySelector('[data-gallery-next]');
    const current = gallery.querySelector('[data-gallery-current]');
    if (!track || !previous || !next) return;
    const move = (direction) => track.scrollBy({ left: track.clientWidth * direction, behavior: 'smooth' });
    previous.addEventListener('click', () => move(-1));
    next.addEventListener('click', () => move(1));
    track.addEventListener('scroll', () => {
      if (current) current.textContent = String(Math.round(track.scrollLeft / track.clientWidth) + 1);
    }, { passive: true });
  });
  document.querySelectorAll('[data-oddcats-root] form[action*="/cart/add"]').forEach((form) => {
    form.addEventListener('submit', async (event) => {
      event.preventDefault();
      const button = form.querySelector('button[type="submit"]');
      if (button) button.disabled = true;
      try {
        const response = await fetch(form.action, { method: 'POST', body: new FormData(form), headers: { Accept: 'application/json' } });
        if (!response.ok) throw new Error('cart');
        window.location.href = '/cart';
      } catch (error) {
        form.submit();
      }
    });
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["oddcats-product"] && !Shopify.designMode) return;
  try {
    
  document.querySelectorAll('[data-product-gallery]').forEach((gallery) => {
    const track = gallery.querySelector('[data-product-track]');
    const previous = gallery.querySelector('[data-product-prev]');
    const next = gallery.querySelector('[data-product-next]');
    const current = gallery.querySelector('[data-product-current]');
    if (!track || !previous || !next) return;
    const move = (direction) => track.scrollBy({ left: track.clientWidth * direction, behavior: 'smooth' });
    previous.addEventListener('click', () => move(-1));
    next.addEventListener('click', () => move(1));
    track.addEventListener('scroll', () => {
      if (current) current.textContent = String(Math.round(track.scrollLeft / track.clientWidth) + 1);
    }, { passive: true });
  });

  } catch(e) { console.error(e); }
})();
})();
